import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
export default class CustomEmojiModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "emojiName", '');
    _defineProperty(this, "imageUrl", '');
    _defineProperty(this, "isCopied", false);
    _defineProperty(this, "isCopying", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.emojiName = this.attrs.name || '';
    const baseUrl = app.forum.attribute('baseUrl').replace(/\/$/, '');
    this.imageUrl = this.attrs.src || "".concat(baseUrl, "/api/custom-emojis/").concat(this.emojiName);
  }
  className() {
    return 'CustomEmojiModal Modal--small';
  }
  title() {
    return ":".concat(this.emojiName, ":");
  }
  content() {
    return m("div", {
      className: "Modal-body CustomEmojiModal-body"
    }, m("div", {
      className: "CustomEmojiModal-preview"
    }, m("img", {
      src: this.imageUrl,
      alt: this.emojiName,
      className: "CustomEmojiModal-image"
    })), m("div", {
      className: "CustomEmojiModal-actions"
    }, m(Button, {
      className: "Button ".concat(this.isCopied ? 'Button--success' : 'Button--primary', " CustomEmojiModal-copyBtn"),
      icon: this.isCopied ? 'fas fa-check' : 'fas fa-copy',
      loading: this.isCopying,
      onclick: this.copyForWhatsApp.bind(this)
    }, this.isCopied ? '¡Sticker Copiado!' : 'Copiar para WhatsApp'), m(Button, {
      className: "Button CustomEmojiModal-closeBtn",
      onclick: () => app.modal.close()
    }, "Cerrar")));
  }
  async copyForWhatsApp() {
    if (this.isCopying) return;
    this.isCopying = true;
    m.redraw();
    try {
      // Fetch the emoji image blob
      const response = await fetch(this.imageUrl);
      const blob = await response.blob();

      // Convert to PNG blob if needed because navigator.clipboard only accepts image/png
      let pngBlob = blob;
      if (blob.type !== 'image/png') {
        pngBlob = await this.convertToPng(blob);
      }

      // Clipboard Item write
      if (navigator.clipboard && window.ClipboardItem) {
        const item = new ClipboardItem({
          'image/png': pngBlob
        });
        await navigator.clipboard.write([item]);
        this.isCopied = true;
        app.alerts.show({
          type: 'success'
        }, '¡Sticker copiado al portapapeles! Ya puedes pegarlo en WhatsApp.');
      } else {
        // Fallback: copy image URL
        await navigator.clipboard.writeText(this.imageUrl);
        app.alerts.show({
          type: 'info'
        }, 'Enlace de la imagen copiado al portapapeles.');
      }
    } catch (err) {
      console.error('Error copying custom emoji to clipboard:', err);
      // Si falla por estar en HTTP o permisos restringidos, intentamos el fallback tradicional
      let copiedFallback = false;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(this.imageUrl);
          copiedFallback = true;
        }
      } catch (e) {
        copiedFallback = false;
      }
      if (!copiedFallback) {
        // Fallback clásico con textarea invisible (funciona 100% en HTTP sin SSL)
        try {
          const textArea = document.createElement('textarea');
          textArea.value = this.imageUrl;
          textArea.style.position = 'fixed';
          textArea.style.opacity = '0';
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          copiedFallback = document.execCommand('copy');
          document.body.removeChild(textArea);
        } catch (e) {
          copiedFallback = false;
        }
      }
      if (copiedFallback) {
        app.alerts.show({
          type: 'info'
        }, 'Enlace de la imagen copiado al portapapeles (en producción con HTTPS se copiará directamente la imagen para WhatsApp).');
      } else {
        app.alerts.show({
          type: 'error'
        }, 'No se pudo copiar automáticamente. Puedes mantener pulsada la imagen para guardarla.');
      }
    } finally {
      this.isCopying = false;
      m.redraw();
      if (this.isCopied) {
        setTimeout(() => {
          this.isCopied = false;
          m.redraw();
        }, 3000);
      }
    }
  }
  convertToPng(blob) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      const url = URL.createObjectURL(blob);
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth || 512;
        canvas.height = img.naturalHeight || 512;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          URL.revokeObjectURL(url);
          return resolve(blob);
        }
        ctx.drawImage(img, 0, 0);
        URL.revokeObjectURL(url);
        canvas.toBlob(pngBlob => {
          if (pngBlob) {
            resolve(pngBlob);
          } else {
            resolve(blob);
          }
        }, 'image/png');
      };
      img.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error('Failed to load image for PNG conversion'));
      };
      img.src = url;
    });
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/custom-emojis/CustomEmojiModal', CustomEmojiModal);